import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-menu',
    template: '<ng-content></ng-content>',
    styleUrl: './menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {}
